import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import AssignmentTurnedIn from '@mui/icons-material/AssignmentTurnedIn';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import DocumentScoringResultSummary from './DocumentScoringResultSummary';
import { TextField, CollapseCard, Button } from '@totalsoft/rocket-ui';
import { withRights } from '../../../../../providers/RightsConsumer';
import { RightsContext } from 'providers/RightsContext';
import { compose } from 'redux';

export const DocumentScoringResultComponent = ({ scoringResult, t, scoringInProgress, rights, generateScoring, viewScoringHistory }) => {
  const { isImage } = useContext(RightsContext);

  return (
    <CollapseCard
      icon={AssignmentTurnedIn}
      title={t('DocumentEdit.Scoring.ScoringResult.Title')}
      subheader={<DocumentScoringResultSummary scoringResult={scoringResult} />}
      hideSubheaderOnExpand
      toggleOnHeaderClick
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <TextField
            disabled
            fullWidth
            value={scoringResult.scoringResult || ''}
            label={t('DocumentEdit.Scoring.ScoringResult.ScoringResult')}
          />
          <TextField
            disabled
            fullWidth
            value={scoringResult.assetScoreClass || ''}
            label={t('DocumentEdit.Scoring.ScoringResult.AssetScoreClass')}
          />
          <TextField
            disabled
            fullWidth
            value={scoringResult.advanceCriterion || ''}
            label={t('DocumentEdit.Scoring.ScoringResult.AdvanceCriterion')}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            disabled
            fullWidth
            value={scoringResult.clientScoreClass || ''}
            label={t('DocumentEdit.Scoring.ScoringResult.ClientScoreClass')}
          />
          <TextField
            disabled
            fullWidth
            value={scoringResult.indebtednessDegree || ''}
            label={t('DocumentEdit.Scoring.ScoringResult.IndebtednessCriterion')}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            disabled
            fullWidth
            value={scoringResult.clientRatingType || ''}
            label={t('DocumentEdit.Scoring.ScoringResult.ClientRatingType')}
          />
          <TextField
            disabled
            fullWidth
            value={scoringResult.knockoutCriterion || ''}
            label={t('DocumentEdit.Scoring.ScoringResult.KnockoutCriterion')}
          />
          {!isImage && (
            <Grid container spacing={1}>
              <Grid item>
                <Button onClick={generateScoring} disabled={rights.readOnlyFull || scoringInProgress}>
                  <HowToRegIcon />
                  {scoringInProgress ? t('DocumentEdit.Scoring.ScoringInProgress') : t('DocumentEdit.Scoring.ProcessScoring')}
                </Button>
              </Grid>
              <Grid item>
                <Button onClick={viewScoringHistory} disabled={rights.readOnlyFull || scoringInProgress}>
                  <HistoryIcon />
                  {t('OfferEdit.ScoringHistory.Title')}
                </Button>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </CollapseCard>
  );
};

DocumentScoringResultComponent.propTypes = {
  scoringResult: PropTypes.object,
  t: PropTypes.func.isRequired,
  scoringInProgress: PropTypes.bool.isRequired,
  generateScoring: PropTypes.func.isRequired,
  viewScoringHistory: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired
};
export default compose(withTranslation(), withRights)(DocumentScoringResultComponent);
